{
    "name": "light-daltonized",
    "primary": "#93c5fd",
    "secondary": "#c4b5fd",
    "success": "#93c5fd",
    "error": "#fbbf24",
    "warning": "#fbbf24",
    "text": "#e5e7eb",
    "textDim": "#6b7280",
    "textMuted": "#9ca3af",
    "secondaryText": "#999999",
    "border": "#374151",
    "background": "",
    "accent": "#a5b4fc",
    "toolName": "#93c5fd",
    "toolSuccess": "#93c5fd",
    "toolError": "#fbbf24",
    "diffAdded": "#93c5fd",
    "diffRemoved": "#fbbf24",
    "diffContext": "#6b7280",
    "diffAddedDimmed": "#bfdbfe",
    "diffRemovedDimmed": "#fde68a",
    "diffAddedWord": "#60a5fa",
    "diffRemovedWord": "#f59e0b",
    "diffAddedWordDimmed": "#93c5fd",
    "diffRemovedWordDimmed": "#fbbf24",
    "diffAddedBackground": "#bfdbfe",
    "diffAddedBackgroundText": "#1e3a8a",
    "diffAddedBackgroundWord": "#1d4ed8",
    "diffRemovedBackground": "#fde68a",
    "diffRemovedBackgroundText": "#78350f",
    "diffRemovedBackgroundWord": "#b45309",
    "spinnerColor": "#93c5fd",
    "claude": "#fb923c",
    "claudeShimmer": "#fdba74",
    "permission": "#a5b4fc",
    "permissionShimmer": "#c7d2fe",
    "inputPrompt": "#93c5fd",
    "footerText": "#6b7280",
    "commandColor": "#a5b4fc",
    "planPrimary": "#fbbf24",
    "planBorder": "#f59e0b",
    "subtle": "#4b5563",
    "link": "#93c5fd",
    "code": "#fbbf24",
    "subagent1": "#fbbf24",
    "subagent2": "#93c5fd",
    "subagent3": "#a5b4fc",
    "subagent4": "#c4b5fd",
    "subagent5": "#c084fc",
    "subagent6": "#fb923c",
    "subagent7": "#a5b4fc",
    "subagent8": "#22d3ee",
    "language": "#0e7490"
}
